<template lang="html">
  <pl-dialog
    :header="'Role has changed'"
    :headerStyle="'font-weight: bold; font-size: 24px'"
    :maxWidth="'600px'"
    :padding="'20px'"
  >
    <div class="center-xs">
      <div class="mt2 pl-subheading">
        Your account role has been changed by an administrator.
        </br>
        You must log out then back in to continue.
      </div>
      <div class="mt3">
        <pl-button
          @click.native="logOut"
          class="pl-primary"
          style="padding: 3px 30px;"
        >
          LOG OUT
        </pl-button>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import authenticationServices from 'features/authentication/authentication.services';
  import { environment } from 'services/apiConfigs';

  export default {
    data() {
      return {};
    },
    computed: {},
    methods: {
      logOut() {
        try {
          if (environment === 'production') {
            window.HelpCrunch('logout');
          }
        } catch (error) {
          console.error(error);
        }
        authenticationServices.logout();
        this.$emit('closeModal');
      },
    },
  };
</script>


// WEBPACK FOOTER //
// roleChangedModal.vue?975a3092